import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    currency: 'DKK',
    enableEnergyLabelLink: true,
};
